import React from 'react';

const Landing = ({}) => (
  <div className="hero-body">
      <div className="container">
          <div className="columns is-vcentered">
              <div className="column is-6">
                  <figure className="">
                      <img src="assets/images/illustrations/drawings/landing5-2.svg" alt="" />
                  </figure>
              </div>
              <div className="column is-5 is-offset-1 is-hero-title">
                  <h2 className="subtitle is-4">
                      <span style={{ color: '#6EBDFF', fontWeight: '700' }}>BÜTÜN</span> iş süreçlerinizde
                  </h2>
                  <h1 className="title is-1 is-bigger">
                      Dijitalleşin.
                  </h1>
                  <h2 className="subtitle is-4">
                      Şirketinizin dijital dönüşümünde, sizin için en doğru çözümleri sunuyoruz.
                  </h2>
                  <p className="">
                      <a href="#test" className="button button-cta is-bold btn-align secondary-btn raised">
                          Çözümlerimizi İnceleyin
                      </a>
                  </p>
              </div>
          </div>
      </div>
  </div>
);

export default Landing;
